import Vue from 'vue';
import Router from 'vue-router';

// 导入组件
import HomePage from '@/views/HomePage';

Vue.use(Router);

export default new Router({
  mode: 'history', // 使用 HTML5 History 模式（去掉 URL 中的 #）
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
    },
    {
      path: '/:pathMatch(.*)*',  // 404 页面
      redirect: '/'  // 或指向专门的 404 组件
    }
  ],
});